import Button, { ButtonProps as IButtonProps } from './Button';
export default Button;
export type ButtonProps = IButtonProps;
